import React from 'react'
import { connect } from 'react-redux'

import tooltips from '../constants/tooltips.json'

import {
  openPreferences
} from '../actions'

const PreferencesButton = (props) => {
  const {
    onOpenPreferences,
    showTooltips
  } = props

  return (
    <div
      className="preferences-btn"
      data-tip={tooltips['preferences_open']}
      data-multiline="true"
      data-place="left"
      data-offset="{'bottom': 20}"
      data-tip-disable={!showTooltips}
    >
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 96 96" onClick={onOpenPreferences}>
        <path
          id="gear"
          d="M69.7,50.9c0.1-0.9,0.2-1.9,0.2-2.9s-0.1-1.9-0.2-2.9l6.2-4.8c0.6-0.4,0.7-1.2,0.4-1.9 l-5.8-10.1c-0.4-0.6-1.1-0.9-1.8-0.6l-7.3,2.9c-1.5-1.2-3.2-2.1-4.9-2.9l-1.1-7.7c-0.1-0.7-0.7-1.2-1.4-1.2H42.2 c-0.7,0-1.3,0.5-1.4,1.2l-1.1,7.7c-1.8,0.7-3.4,1.7-4.9,2.9l-7.3-2.9c-0.7-0.3-1.4,0-1.8,0.6l-5.8,10.1c-0.4,0.6-0.2,1.4,0.4,1.9 l6.2,4.8c-0.1,0.9-0.2,1.9-0.2,2.9s0.1,1.9,0.2,2.9l-6.2,4.8c-0.6,0.4-0.7,1.2-0.4,1.9l5.8,10.1c0.3,0.6,1.1,0.9,1.8,0.6l7.3-2.9 c1.5,1.2,3.2,2.1,4.9,2.9l1.1,7.7c0.1,0.7,0.7,1.2,1.4,1.2h11.7c0.7,0,1.3-0.5,1.4-1.2l1.1-7.7c1.8-0.7,3.4-1.7,4.9-2.9l7.3,2.9 c0.7,0.3,1.4,0,1.8-0.6l5.8-10.1c0.3-0.6,0.2-1.4-0.4-1.9L69.7,50.9z M48,58.2c-5.6,0-10.2-4.6-10.2-10.2S42.4,37.8,48,37.8 S58.2,42.4,58.2,48S53.6,58.2,48,58.2z"
          fill="#666"
        />
      </svg>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpenPreferences: () => {
      dispatch(openPreferences(true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesButton)
